import type { Lang } from "@iyk/vf-app-config"

const translations: Translations = {
  EN: {
    LinkDestroyed: {
      title: "Link Destroyed",
      description:
        "This tap experience is non-shareable and this link has expired. Tap the product again to gain access"
    },
    Terms: {
      intro:
        "By signing up, you have read, understood, and agree to the processing of your data and use of cookies in accordance with IYK's",
      privacy: (brand) => `${brand ? `${brand}'s ` : ""}Privacy Policy`,
      and: "and",
      terms: (brand) => `${brand ? `${brand}'s ` : ""}Terms of Service`,
      artistPrivacyPrefix: "and the"
    },
    ResendOtpCodeButton: {
      idle: {
        resend: "Resend code"
      },
      sent: {
        codeSent: "Code sent"
      }
    },
    Footer: {
      contactSupport: "Contact Support",
      poweredBy: "Powered by IYK"
    },
    AudioPlayerDrawer: {
      downloadToDevice: "Download to this device",
      download: "Download",
      or: "or",
      sendLinkTo: (email) => `Send link to ${email ?? "email"}`,
      yourEmail: "Your email",
      submit: "Submit",
      send: "Send",
      downloadStarted: "Download started",
      downloadLinkSent: "Download link sent successfully",
      track: "track",
      tracks: "tracks"
    }
  },
  ES: {
    LinkDestroyed: {
      title: "Link Destruido",
      description:
        "Esta experiencia de toque no es compartible y este enlace ha expirado. Toca el producto nuevamente para acceder"
    },
    Terms: {
      intro:
        "Al registrarte, declaras que has leído, entendido y aceptas el tratamiento de tus datos y el uso de cookies de acuerdo con la",
      privacy: (brand) => `Política de Privacidad${brand ? ` de ${brand}` : ""}`,
      and: "y",
      terms: (brand) => `Términos y Condiciones de ${brand}`,
      artistPrivacyPrefix: "y la"
    },
    ResendOtpCodeButton: {
      idle: {
        resend: "Reenviar código"
      },
      sent: {
        codeSent: "Código enviado"
      }
    },
    Footer: {
      contactSupport: "Contactar a soporte",
      poweredBy: "Powered by IYK"
    },
    AudioPlayerDrawer: {
      downloadToDevice: "Descargar en este dispositivo",
      download: "Descargar",
      or: "o",
      sendLinkTo: (email) => `Enviar enlace a ${email ?? "correo electrónico"}`,
      yourEmail: "Tu correo electrónico",
      submit: "Enviar",
      send: "Enviar",
      downloadStarted: "Descarga iniciada",
      downloadLinkSent: "Enlace de descarga enviado con éxito",
      track: "canción",
      tracks: "canciones"
    }
  },

  KO: {
    LinkDestroyed: {
      title: "링크가 만료되었습니다",
      description: "이 탭 경험은 공유할 수 없으며 링크가 만료되었습니다. 다시 상품을 탭하여 접근해 주세요"
    },
    Terms: {
      intro:
        "가입함으로써 귀하는 IYK의 따라 귀하의 데이터 처리 및 쿠키 사용에 대해 읽고 이해했으며 이에 동의합니다",
      privacy: (brand) => `${brand ? `${brand}의 개인정보 처리 방침` : "개인정보 처리 방침"}`,
      and: "그리고",
      terms: () => "서비스 이용 약관",
      artistPrivacyPrefix: "그리고"
    },
    ResendOtpCodeButton: {
      idle: {
        resend: "코드 재전송"
      },
      sent: {
        codeSent: "코드 전송"
      }
    },
    Footer: {
      contactSupport: "Contact Support",
      poweredBy: "Powered by IYK"
    },
    AudioPlayerDrawer: {
      downloadToDevice: "이 기기에 다운로드",
      download: "다운로드",
      or: "또는",
      sendLinkTo: (email) => `${email ?? "이메일"}로 링크를 보내세요`,
      yourEmail: "이메일",
      submit: "제출",
      send: "보내기",
      downloadStarted: "다운로드가 시작되었습니다",
      downloadLinkSent: "다운로드 링크를 전송했습니다",
      track: "곡",
      tracks: "곡"
    }
  }
}

type Translation = {
  LinkDestroyed: {
    title: string
    description: string
  }
  Terms: {
    intro: string
    privacy: (brand?: string) => string
    and: string
    terms: (brand?: string) => string
    artistPrivacyPrefix: string
  }
  ResendOtpCodeButton: {
    idle: {
      resend: string
    }
    sent: {
      codeSent: string
    }
  }
  Footer: {
    contactSupport: string
    poweredBy: string
  }
  AudioPlayerDrawer: {
    downloadToDevice: string
    download: string
    or: string
    sendLinkTo: (email?: string) => string
    yourEmail: string
    submit: string
    send: string
    downloadStarted: string
    downloadLinkSent: string
    track: string
    tracks: string
  }
}

type Translations = Record<Lang, Translation>

export { translations }
